import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { ImageModule } from 'primeng/image';
import { PanelModule } from 'primeng/panel';
import { PopoverModule } from 'primeng/popover';
import { MessageModule } from 'primeng/message';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule,
    TooltipModule,
    ImageModule,
    PanelModule,
    PopoverModule,
    MessageModule,
  ],
  exports: [
    TranslateModule,
    TooltipModule,
    ImageModule,
    PanelModule,
    PopoverModule,
    MessageModule,
  ]
})
export class SharedModule { }
